import { storage } from './storage';

const key = '_initialRoute';

const get = () => storage.getItem(key) || '/';

const set = (route: string) => storage.setItem(key, route);

const clear = () => storage.removeItem(key);

const clearIf = (route: string) => route === storage.getItem(key) && clear();

export const initialRoute = {
  set, get, clear, clearIf,
};
